import React from "react"
import PropTypes from "prop-types"
import withStyles from "@material-ui/core/styles/withStyles"
import { Popup } from "react-leaflet"

const styles = (theme) => ({
	popup: {
		textAlign: "center",
		cursor: "pointer",
	},
	popupId: {
		fontWeight: "bold",
	},
	close: {
		position: "absolute",
		right: 0,
		top: 0,
		padding: 3,
		paddingRight: 8,
		cursor: "pointer",
	},
	nav: {
		color: theme.palette.primary.main,
		fontWeight: "bold",
	},
})

const NodePopup = ({
	classes,
	mLocId,
	position,
	setNodeInactive,
	nId,
	rowNum,
	fromSouth,
	handleClick,
	nav,
	nodeDataNodeId,
}) => {
	if (position.length !== 2) return null

	let originalNodeId

	if (nodeDataNodeId && nodeDataNodeId !== nId) {
		originalNodeId = nodeDataNodeId
	}

	return (
		<Popup position={position} closeButton={false} closeOnClick={false} autoClose={false} autoPan={false}>
			<div>
				<div className={classes.close} onClick={setNodeInactive}>
					x
				</div>
				<div className={classes.popup} onClick={handleClick}>
					{nav && <div className={classes.nav}>You Are Here</div>}
					<div className={classes.popupId}>Node ID: {nId ? `0x${nId.slice(-4)}` : "Not Assigned"}</div>
					{originalNodeId ? <div>Original Node ID: {`0x${originalNodeId.slice(-4)}`}</div> : null}
					<div>Row: {rowNum}</div>
					<div>From South: {fromSouth}</div>
				</div>
			</div>
		</Popup>
	)
}

NodePopup.propTypes = {
	classes: PropTypes.object.isRequired,
	position: PropTypes.array.isRequired,
	setNodeInactive: PropTypes.func.isRequired,
}

export default withStyles(styles)(NodePopup)
